<template>
  <wb-modal
    v-if="show"
    ref="modalRef"
    class="emh-ui-modal"
    :active-level.attr="activeLevel"
    :close-on-backdrop-click.attr="closeOnBackdropClick"
    :close-on-escape-key.attr="closeOnEscapeKey"
    :mode.attr="mode"
    :scroll-lock.attr="scrollLock"
    @wbclose="onClose"
    @wblevelchange="onLevelChange"
  >
    <template v-if="$slots.default">
      <slot></slot>
    </template>
    <template v-else>
      <wb-modal-header><slot name="header"></slot></wb-modal-header>
      <wb-modal-content :headline.attr="headline"><slot name="content"></slot></wb-modal-content>
      <wb-modal-footer v-if="$slots.footer"><slot name="footer"></slot></wb-modal-footer>
    </template>
  </wb-modal>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { Components } from '@workbench/core';

export default defineComponent({
  name: 'UiModalWindow',
  props: {
    show: {
      type: Boolean,
    },
    activeLevel: {
      type: Number,
      default: 1,
    },
    closeOnBackdropClick: {
      type: Boolean,
      default: true,
    },
    closeOnEscapeKey: {
      type: Boolean,
      default: true,
    },
    mode: {
      type: String,
      required: true,
    },
    scrollLock: {
      type: Boolean,
      default: true,
    },
    headline: {
      type: String,
      default: '',
    },
  },
  emits: ['close', 'level-change'],
  setup(_props, { emit }) {
    const modalRef = ref<Components.WbModal>();

    const onClose = async () => {
      await modalRef.value?.runLeaveAnimation();
      emit('close');
    };

    const onLevelChange = (event: CustomEvent) => {
      emit('level-change', event.detail);
    };

    return { onClose, onLevelChange, modalRef };
  },
});
</script>

<style lang="scss">
.emh-ui-modal {
  // needs to be above dcp-sticky-bar and dcp-sticky-bar be part of our standard z-index function
  // since it needs to be above fcis price popup on the srp
  z-index: 1002;

  .wb-modal__outer {
    @include breakpoint-from(mq4) {
      width: calc(8 / 12 * 100%) !important;

      // set a max width depending of the shop containers max width (1920px)
      max-width: calc(#{$wb-content-area-max-width}/ 12 * 8);
    }
  }
}
</style>
